import * as jsxRuntime from "/Users/paulosantana/dev/tke/riat-pwa/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment